import React from "react";

const DIFF_STYLE = {
  facile: "bg-green-100 text-green-700",
  equilibrato: "bg-blue-100 text-blue-700",
  tosto: "bg-red-100 text-red-700",
};

export function VirtualFriendsList({ data, lang = "it", t, onChallenge, loading = false }) {
  const bots = data?.bots || [];
  return (
    <div data-testid="virtual-friends-section">
      <div className="flex items-center justify-between mb-3">
        <div>
          <h3 className="text-xl font-bold text-white">🤖 {t.virtualFriends}</h3>
          <p className="text-white/80 text-sm">{t.virtualFriendsDesc}</p>
        </div>
        {data?.streak > 0 && (
          <span className="bg-amber-400 text-amber-900 font-bold px-3 py-1 rounded-full text-sm whitespace-nowrap" data-testid="virtual-streak">
            🔥 {data.streak}
          </span>
        )}
      </div>
      <div className="space-y-3" data-testid="virtual-friends-list">
        {bots.map((b, i) => (
          <div
            key={b.id}
            className="bg-white rounded-2xl p-4 shadow-lg flex items-center justify-between animate-[fadeIn_0.4s_ease-out_both]"
            style={{ animationDelay: `${i * 60}ms` }}
            data-testid={`virtual-friend-${b.id}`}
          >
            <div className="flex items-center gap-3 min-w-0">
              <span className="text-4xl">{b.avatar}</span>
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-lg font-bold text-gray-800">{b.name}</span>
                  <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${DIFF_STYLE[b.difficulty]}`} data-testid={`virtual-friend-diff-${b.id}`}>
                    {t[`diff${b.difficulty.charAt(0).toUpperCase() + b.difficulty.slice(1)}`]}
                  </span>
                </div>
                <div className="text-xs text-gray-500 truncate">{lang === "it" ? b.bio_it : b.bio_en}</div>
                <div className="text-xs text-gray-400" data-testid={`virtual-friend-record-${b.id}`}>
                  {t.yourRecord}: {b.record.wins}W · {b.record.losses}L
                </div>
              </div>
            </div>
            <button
              onClick={() => onChallenge(b.id)}
              disabled={loading}
              className="bg-gradient-to-r from-purple-600 to-pink-500 text-white px-4 py-2 rounded-full font-bold hover:opacity-90 hover:scale-105 transition-transform disabled:opacity-50 whitespace-nowrap"
              data-testid={`virtual-challenge-${b.id}`}
            >
              ⚔️ {t.challengeBtn}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
